import styled from 'styled-components';
import { breakpoint } from '@sketch/global-styles';
import { Link } from '@sketch/components';
import '../ResponsiveImage/index.js';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage.js';

const StyledResponsiveImage = styled(ResponsiveImage) `
  width: 100%;
  margin-bottom: 8px;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.radii.xlarge};
  overflow: hidden;

  ${breakpoint('base', 'md') `
    aspect-ratio: 1/1;
  `}
`;
const Title = styled.h1 `
  margin: 0 0 4px 0;
  font-size: ${({ theme }) => theme.fontSizes.F};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  transition: color ${({ theme }) => theme.transitions.duration[1]};
`;
const Description = styled.p `
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;
const ReadMore = styled.p `
  position: relative;
  text-decoration: none;
  transition: color ${({ theme }) => theme.transitions.duration[1]};
  color: currentColor;
`;
const StyledLink = styled(Link) `
  display: block;
  position: relative;
  font-size: ${({ theme }) => theme.fontSizes.E};

  /* Reset all link styles */
  text-decoration: none;
  transition: none;
  white-space: pre-wrap;
  color: currentColor;

  &:hover {
    ${Title} {
      color: ${({ theme }) => theme.colors.foreground.secondary.D};
    }

    ${ReadMore} {
      text-decoration: underline;

      &:hover {
        color: currentColor;
      }

      &:active {
        color: currentColor;
      }
    }
  }
`;

export { Description, ReadMore, StyledLink, StyledResponsiveImage, Title };
